import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function useReveal() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { el.classList.add('visible'); obs.unobserve(el); } },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

export default function HomeFinalCta() {
  const ref = useReveal();
  return (
    <section className="relative py-20 sm:py-28">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/5b8fc64ae8c7e08d0b9c1ebfff9c74b8.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-[#0D1E3A]/85"></div>
      </div>
      <div ref={ref} className="reveal relative z-10 max-w-3xl mx-auto px-5 sm:px-6 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C8923A] mb-5 font-medium">Let's Get Started</p>
        <h2 className="font-cormorant text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-tight mb-6">
          Ready to Make <em className="not-italic font-semibold">Your Move?</em>
        </h2>
        <p className="text-white/70 mb-8 sm:mb-10 leading-relaxed">
          No pressure. Just honest guidance from someone who knows homes inside and out. Let's talk about your goals.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
          <a
            href="tel:+15176629155"
            className="px-7 py-3.5 sm:px-8 sm:py-4 bg-[#C8923A] text-white text-sm font-semibold rounded-md hover:bg-[#B07B2A] transition-all whitespace-nowrap inline-flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line"></i>
            Call Kendrick
          </a>
          <a
            href="mailto:ktaylor@xsellrealty.net"
            className="px-7 py-3.5 sm:px-8 sm:py-4 bg-white/10 border border-white/30 text-white text-sm font-semibold rounded-md hover:bg-white/20 transition-all whitespace-nowrap inline-flex items-center justify-center gap-2"
          >
            <i className="ri-mail-line"></i>
            Send an Email
          </a>
          <Link
            to="/contact"
            className="px-7 py-3.5 sm:px-8 sm:py-4 border border-[#C8923A] text-[#C8923A] text-sm font-semibold rounded-md hover:bg-[#C8923A] hover:text-white transition-all whitespace-nowrap inline-flex items-center justify-center"
          >
            Schedule a Call
          </Link>
        </div>
      </div>
    </section>
  );
}
